import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/40_mountains_lake/40_mountains_lake"
 * Contains 1 texture(s)
 */
export class Tablet40MountainsLakeAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/40_mountains_lake/40_mountains_lake';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '40_mountains_lake.jpg'
    ] as const;
}
